(() => {
  if (window.fgBfcmReady) return;
  window.fgBfcmReady = true;
  let trigger = null;
  const dialog = () => document.getElementById('FgBfcmDialog');
  const offerKeys = ['heat-pump', 'water-ultra', 'water-9pro', 'furnace'];
  const validVariant = value => /^\d{1,20}$/.test(value || '') ? value : '';
  const storageKey = () => 'fg-bfcm-offer:' + window.location.pathname;
  const prepareReturn = form => {
    const select = form.querySelector('[data-fg-bfcm-select]');
    const key = select?.selectedOptions[0]?.dataset.key;
    if (!offerKeys.includes(key)) return;
    const variant = validVariant(form.querySelector('[data-fg-bfcm-variant-field]')?.value);
    const target = new URL(window.location.pathname, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);
    const view = currentParams.get('view');
    const previewTheme = currentParams.get('preview_theme_id');
    if (/^[a-z0-9][a-z0-9_-]{0,63}$/i.test(view || '')) target.searchParams.set('view', view);
    if (/^\d{1,20}$/.test(previewTheme || '')) target.searchParams.set('preview_theme_id', previewTheme);
    target.searchParams.set('contact_posted', 'true');
    target.searchParams.set('fg_bfcm_offer', key);
    if (variant) target.searchParams.set('fg_bfcm_variant', variant);
    target.hash = form.id;
    let field = form.querySelector('[name="return_to"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      form.append(field);
    }
    field.value = target.pathname + target.search + target.hash;
    return {key, variant};
  };
  const showClaim = (form, key, variant = '') => {
    const select = form.querySelector('[data-fg-bfcm-success-select]');
    if (!select || !offerKeys.includes(key)) return;
    select.value = key;
    form.querySelectorAll('[data-fg-bfcm-code-panel]').forEach(panel => {
      panel.hidden = panel.dataset.fgBfcmCodePanel !== key;
      const apply = panel.querySelector('[data-fg-bfcm-apply]');
      if (!apply) return;
      const destination = new URL(apply.dataset.productPath, window.location.origin);
      const selectedVariant = validVariant(variant);
      if (!panel.hidden && selectedVariant) destination.searchParams.set('variant', selectedVariant);
      const link = new URL(apply.href, window.location.origin);
      link.searchParams.set('redirect', destination.pathname + destination.search);
      apply.href = link.pathname + link.search;
    });
  };
  const restoreClaim = form => {
    const select = form.querySelector('[data-fg-bfcm-success-select]');
    if (!select) return;
    const params = new URLSearchParams(window.location.search);
    const queryKey = params.get('fg_bfcm_offer');
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey()) || 'null'); } catch {}
    const key = offerKeys.includes(queryKey) ? queryKey : offerKeys.includes(saved?.key) ? saved.key : select.value;
    const variant = offerKeys.includes(queryKey) ? params.get('fg_bfcm_variant') : saved?.key === key ? saved.variant : '';
    showClaim(form, key, variant);
    try { sessionStorage.removeItem(storageKey()); } catch {}
  };
  const copyWithSelection = (panel, value) => {
    const buffer = document.createElement('textarea');
    buffer.value = value;
    buffer.readOnly = true;
    buffer.tabIndex = -1;
    buffer.className = 'fg-bfcm-copy-buffer';
    buffer.setAttribute('aria-hidden', 'true');
    const active = document.activeElement;
    // A modal makes nodes outside it inert. Keep the copy buffer inside it.
    panel.append(buffer);
    try {
      buffer.focus({preventScroll:true});
      buffer.select();
      buffer.setSelectionRange(0, value.length);
      return document.execCommand('copy') === true;
    } catch {
      return false;
    } finally {
      buffer.remove();
      active?.focus({preventScroll:true});
    }
  };
  const copyCode = async button => {
    const panel = button.closest('[data-fg-bfcm-code-panel]');
    const code = panel?.querySelector('[data-fg-bfcm-code]');
    const status = panel?.querySelector('[data-fg-bfcm-copy-status]');
    if (!code || !status || button.dataset.copyState === 'copying') return;
    const value = code.textContent.trim();
    if (!value) return;
    button.dataset.copyLabel ||= button.textContent;
    button.dataset.copyState = 'copying';
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.copying;
    status.textContent = '';
    let timeout;
    try {
      // Try while the click still has user activation; permission prompts can
      // otherwise leave clipboard.writeText pending indefinitely.
      if (!copyWithSelection(panel, value)) {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await Promise.race([
          navigator.clipboard.writeText(value),
          new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Clipboard timeout')), 2500); })
        ]);
      }
      button.dataset.copyState = 'copied';
      button.textContent = button.dataset.copiedLabel;
      status.textContent = button.dataset.copied;
    } catch {
      delete button.dataset.copyState;
      button.textContent = button.dataset.copyLabel;
      code.focus({preventScroll:true});
      const range = document.createRange();
      range.selectNodeContents(code);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      status.textContent = button.dataset.copyManual;
    } finally {
      clearTimeout(timeout);
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  };
  const submissions = new WeakMap();
  const resetSubmission = (form, message = '') => {
    const pending = submissions.get(form);
    if (!pending) return;
    pending.timers.forEach(clearTimeout);
    pending.label.textContent = pending.originalLabel;
    pending.button.removeAttribute('aria-busy');
    pending.button.removeAttribute('aria-disabled');
    pending.status.textContent = message;
    pending.status.hidden = !message;
    delete form.dataset.fgBfcmSubmitting;
    submissions.delete(form);
  };
  const startSubmission = form => {
    if (submissions.has(form)) return;
    const button = form.querySelector('[data-fg-bfcm-submit]');
    const label = form.querySelector('[data-fg-bfcm-submit-label]');
    const status = form.querySelector('[data-fg-bfcm-submit-status]');
    if (!button || !label || !status) return;
    const pending = {button, label, status, originalLabel:label.textContent, timers:[]};
    submissions.set(form, pending);
    form.dataset.fgBfcmSubmitting = 'true';
    button.setAttribute('aria-busy', 'true');
    // Keep the native button enabled so Shopify CAPTCHA can resume submission.
    button.setAttribute('aria-disabled', 'true');
    label.textContent = button.dataset.submitting;
    status.hidden = false;
    status.textContent = status.dataset.waiting;
    pending.timers.push(setTimeout(() => { status.textContent = status.dataset.slow; }, 8000));
    pending.timers.push(setTimeout(() => {
      resetSubmission(form, navigator.onLine === false ? status.dataset.offline : status.dataset.retry);
    }, 30000));
  };
  const updateProduct = (form, key, variant = '') => {
    const select = form?.querySelector('[data-fg-bfcm-select]');
    if (!select) return;
    const option = Array.from(select.options).find(item => item.dataset.key === key);
    if (option) select.value = option.value;
    const selected = select.selectedOptions[0];
    form.querySelector('[data-fg-bfcm-handle]').value = selected?.dataset.handle || '';
    form.querySelector('[data-fg-bfcm-variant-field]').value = variant;
    updateSummary(form, selected);
    prepareReturn(form);
  };
  const updateSummary = (form, selected) => {
    const amount = selected?.dataset.amount || '';
    form.querySelectorAll('[data-fg-bfcm-saving], [data-fg-bfcm-submit-label]').forEach(node => {
      if (form.dataset.fgBfcmSubmitting && node.matches('[data-fg-bfcm-submit-label]')) return;
      node.textContent = (node.dataset.pattern || '').replace('[amount]', amount);
    });
  };
  const openDialog = () => {
    const node = dialog();
    if (!node || typeof node.showModal !== 'function') return false;
    if (!node.open) node.showModal();
    document.documentElement.classList.add('fg-bfcm-dialog-open');
    return true;
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-fg-bfcm-open]');
    if (opener) {
      const form = document.querySelector('[data-fg-bfcm-landing-form] .fg-bfcm-form') || dialog()?.querySelector('.fg-bfcm-form');
      if (!form) return;
      const campaignPage = opener.closest('[data-labor-day-page]');
      const scope = campaignPage ? opener.closest('[data-ld-product-form]') : opener.closest('[data-section-id]') || opener.closest('.shopify-section');
      const productForm = scope?.querySelector('form[is="product-form"]') || scope?.querySelector('form[action*="/cart/add"]');
      const currentVariant = productForm && Array.from(productForm.elements).find(field => field.name === 'id' && !field.disabled);
      const variant = currentVariant?.value || opener.dataset.fgBfcmVariant || '';
      updateProduct(form, opener.dataset.fgBfcmProduct, variant);
      showClaim(form, opener.dataset.fgBfcmProduct, variant);
      trigger = opener;
      if (dialog() && openDialog()) {
        event.preventDefault();
        (form.querySelector('[name="contact[email]"]') || form.querySelector('[data-fg-bfcm-result="success"]'))?.focus({preventScroll:true});
      } else if (!dialog()) {
        event.preventDefault();
        form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
        (form.querySelector('[name="contact[email]"]') || form.querySelector('[data-fg-bfcm-result="success"]'))?.focus({preventScroll:true});
      }
    }
    if (event.target.closest('[data-fg-bfcm-close]')) dialog()?.close();
    const copyButton = event.target.closest('[data-fg-bfcm-copy]');
    if (copyButton) copyCode(copyButton);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-fg-bfcm-success-select]')) {
      showClaim(event.target.closest('form'), event.target.value);
    }
    if (event.target.matches('[data-fg-bfcm-select]')) {
      updateProduct(event.target.closest('form'), event.target.selectedOptions[0]?.dataset.key);
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-fg-bfcm-submit]');
    if (event.isTrusted && button && submissions.has(button.closest('.fg-bfcm-form'))) event.preventDefault();
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches('.fg-bfcm-form')) return;
    const selection = prepareReturn(event.target);
    if (selection) {
      try { sessionStorage.setItem(storageKey(), JSON.stringify(selection)); } catch {}
    }
    startSubmission(event.target);
  }, true);
  document.addEventListener('invalid', event => {
    const form = event.target.closest('.fg-bfcm-form');
    if (form) resetSubmission(form);
  }, true);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.fg-bfcm-form').forEach(form => resetSubmission(form));
  });
  const init = () => {
    document.querySelectorAll('.fg-bfcm-form').forEach(form => {
      updateSummary(form, form.querySelector('[data-fg-bfcm-select]')?.selectedOptions[0]);
      prepareReturn(form);
      if (!form.dataset.claimInitialized) {
        restoreClaim(form);
        form.dataset.claimInitialized = 'true';
      }
      const source = form.querySelector('[data-fg-bfcm-source]');
      if (source) source.value = window.location.origin + window.location.pathname;
      const attribution = form.querySelector('[data-fg-bfcm-attribution]');
      if (attribution) {
        const params = new URLSearchParams(window.location.search);
        attribution.value = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].filter(key => params.has(key)).map(key => `${key}=${params.get(key).slice(0,200)}`).join(' | ');
      }
    });
    const node = dialog();
    if (!node || node.dataset.initialized) return;
    node.dataset.initialized = 'true';
    node.addEventListener('close', () => {
      document.documentElement.classList.remove('fg-bfcm-dialog-open');
      trigger?.focus({preventScroll:true});
    });
    node.addEventListener('click', event => {
      if (event.target !== node) return;
      const box = node.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) node.close();
    });
    const result = node.querySelector('[data-fg-bfcm-result]');
    if (result && openDialog()) result.focus();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
